export default "__VITE_ASSET__CiHoHhBo__"